import { render, staticRenderFns } from "./AddressStep.vue?vue&type=template&id=60f73750"
import script from "./AddressStep.vue?vue&type=script&lang=ts"
export * from "./AddressStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports